import SideMenu from '@/containers/side-menu/SideMenu.vue'
import ReportSyntheticCredit from '@/pages/report-synthetic-credit/ReportSyntheticCredit'

export default {
  path: '/report-synthetic-credit',
  name: 'ReportSyntheticCredit',
  components: {
    mainContent: ReportSyntheticCredit,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'report-notify'
    },
    breadcrumb: {
      title: 'Relatório Sintético de Créditos',
      paths: [
        { title: 'Relatórios' },
        { title: 'Crédito Sintético' }
      ]
    }
  }
}